import React, { useEffect, useState } from "react";
import AddPatient from "../components/modals/AddPatient";
import Table from "../components/ThemeComponent/ThemeDataTable";
import ThemeModal from "../components/ThemeComponent/ThemeModal";
import ThemePagination from "../components/ThemeComponent/ThemePagination";
import ThemeSearchInput from "../components/ThemeComponent/ThemeSearchInput";
import ThemeSort from "../components/ThemeComponent/ThemeSort";
import { PageHeading } from "../components/ThemeComponent/ThemeText";
import { formatTime, success } from "../utils/helpers.js";
import OperationTheater from "../components/modals/OperationTheater";
import {
  useDeleteStaffAttendanceMutation,
  useGetStaffAttendancesQuery,
} from "../Redux/services/ClientAPis/staffAttendance";
import { useSelector } from "react-redux";
import ThemeAddButton from "../components/ThemeComponent/ThemeAddButton.js";
import AddAttendance from "../components/modals/AddAttendance.jsx";
const StaffAttendanceManagement = () => {
  const [loading, setLoading] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [taskView, setTaskView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);
  const [addAtt, setAddAtt] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalData, setModalData] = useState(null);
  const user = useSelector((state) => state.authInfo.user);

  const [selectedValue, setSelectedValue] = useState(10);
  const options = [
    { value: 10, label: "Check In" },
    { value: 20, label: "Check Out" },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetStaffAttendancesQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: page,
        user_role: user?.user_type === "STAFF" ? "staff" : "client",
      },
      { refetchOnMountOrArgChange: true }
    );
  const [deletetask, { isLoading: deleteLoading }] =
    useDeleteStaffAttendanceMutation();

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setPage(data.links.current);
      setTotalRecords(data.links.total_records === 0 ? '' : data.links.total_records);
      setTotalPages(data.links.total);
      // setRowData(data.data);
    }
  }, [data]);

  const onRemoveClick = async () => {
    await deletetask({ id: modalData.id });
    setTimeout(() => {
      setRemoveOpen(false);
      success("Successfully Removed");
      refetch();
    }, 500);
  };

  const header = [
    {
      title: "Day",
      dataIndex: "day",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <p>{formatTime(rowData?.attendance_date)}</p>;
      },
    },
    {
      title: "Date",
      dataIndex: "attendance_date",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Check In",
      dataIndex: "checkin_at",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Check Out",
      dataIndex: "checkout_at",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    // {
    //   title: "Tasks",
    //   dataIndex: "notes",
    //   style: { textAlign: "left" },
    //   elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    //   render: (_, rowData) => {
    //     return (
    //       <div
    //         className="cursor text-decoration-underline"
    //         onClick={() => setTaskView(true)}
    //       >
    //         {rowData?.notes}
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Status ",
      dataIndex: "Status ",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData) => {
        return rowData.slug % 2 === 0 ? (
          <div className="completed_status flex-custom-center">Completed</div>
        ) : (
          <div className="pending_status flex-custom-center"> Pending</div>
        );
      },
    },
  ];

  // const data = [
  //   {
  //     slug: 1,
  //     client_name: "Cameron Williamson",
  //     phone: "(603) 555-0123",
  //     email: "nathan.roberts@example.com",
  //     designation: "Physician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //     Status: "Completed",
  //   },
  //   {
  //     slug: 2,
  //     client_name: "Floyd Miles",
  //     phone: "(209) 555-0104",
  //     email: "debbie.baker@example.com",
  //     designation: "Surgeon",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  //   {
  //     slug: 3,
  //     client_name: "Annette Black",
  //     phone: "(704) 555-0127",
  //     email: "debbie.lawson@example.com",
  //     designation: "Radiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  //   {
  //     slug: 4,
  //     client_name: "Theresa Webb",
  //     phone: "(808) 555-0111",
  //     email: "novah.simmons@example.com",
  //     designation: "Neurologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  //   {
  //     slug: 5,
  //     client_name: "Kathryn Murphy",
  //     phone: "(307) 555-0133",
  //     email: "jessica.hanson@example.com",
  //     designation: "Physiotherapist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  //   {
  //     slug: 6,
  //     client_name: "Brooklyn Simmons",
  //     phone: "(702) 555-0122",
  //     email: "felicia.reid@example.com",
  //     designation: "Pediatrician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  //   {
  //     slug: 7,
  //     client_name: "Robert Fox",
  //     phone: "(252) 555-0125",
  //     email: "tim.jennings@example.com",
  //     designation: "Gynecologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  //   {
  //     slug: 8,
  //     client_name: "Dianne Russell",
  //     phone: "(201) 555-0124",
  //     email: "curtis.weaver@example.com",
  //     designation: "Anesthesiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  //   {
  //     slug: 9,
  //     client_name: "Leslie Alexander",
  //     phone: "(319) 555-0115",
  //     email: "michelle.rivera@example.com",
  //     designation: "Pathologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  //   {
  //     slug: 10,
  //     client_name: "Devon Lane",
  //     phone: "(207) 555-0119",
  //     email: "dolores.chambers@example.com",
  //     designation: "Oncologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     day:  "Monday",
  //   },
  // ];
  const handleDownloadCLick = () => {
    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
      success("Successfully Downloaded");
    }, 1500);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, [page]);

  const onAddClick = () => {
    setAddAtt(true);
  };

  return (
    <div className="dashboard-page patient-page">
      <div className="header d-flex justify-content-between">
        <PageHeading
          text={user?.user_type === "STAFF" ? "Attendance" : "Staff Attendance"}
          count={totalRecords}
        />
        <div className="d-flex responsive-flex align-items-center gap-3 ms-auto">
        {user?.user_type === "STAFF" && (
            <ThemeAddButton
              text={"Add Attendance"}
              onClick={onAddClick}
              className={"responsive-margin"}
            />
          )}
          <ThemeSort
            selectedValue={selectedValue}
            handleChange={handleChange}
            options={options}
          />
          <ThemeSearchInput setSearchQuery={setSearchQuery} />
        </div>
      </div>
      <div className="table-content mt-2">
        <Table
          header={header}
          data={data?.data}
          loading={isLoading}
          removeText=""
          onEditClick={() => setShowEdit(true)}
          setModalData={setModalData}
          setRemoveOpen={() => setRemoveOpen(true)}
          isAction={false}
        />
      </div>
      <div className="pagination mt-3">
        {/* {!loading && ( */}
          <ThemePagination
            activePage={page}
            totalPages={totalPages}
            setPage={setPage}
            page={page}
          />
        {/* )} */}
      </div>
      {addOpen && (
        <ThemeModal
          size={"md"}
          modalContent={<AddPatient setIsOpen={setAddOpen} />}
          title={"Add Patient"}
          className={"edit-profile"}
          isOpen={addOpen}
          setIsOpen={setAddOpen}
        />
      )}
      {taskView && (
        <ThemeModal
          size={"lg"}
          modalContent={<OperationTheater setIsOpen={setTaskView} />}
          className={"edit-profile"}
          isOpen={taskView}
          setIsOpen={setTaskView}
        />
      )}
      {addAtt && (
        <ThemeModal
          size={"md"}
          modalContent={<AddAttendance setIsOpen={setAddAtt} />}
          className={"edit-profile"}
          isOpen={addAtt}
          setIsOpen={setAddAtt}
        />
      )}
    </div>
  );
};

export default StaffAttendanceManagement;
